export abstract class ConsumerBase {
    public abstract setUserSession(userId: string, gateways: string | string[] | null): void
    public abstract logEvent(eventName: string, params: object): void
}
